import { AxiosInstance } from 'axios';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';

import {
  GroupCreateRequest,
  GroupCreateResponse,
  GroupSearchRequest,
  GroupSearchResponse,
  GroupDeleteRequest,
  GroupDeleteResponse,
} from './GroupService.types';

import { GroupUserService } from './services';

export class GroupService implements Pick<BaseRequestEndpoints, 'create' | 'search' | 'delete'> {
  instance: AxiosInstance;
  user: GroupUserService;
  prefix = '/groups';
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.user = new GroupUserService(instance, this.prefix);
  }

  create(request: GroupCreateRequest) {
    return this.instance.post<GroupCreateResponse>(`${this.prefix}`, request);
  }

  search(request: GroupSearchRequest) {
    return this.instance.get<GroupSearchResponse>(`${this.prefix}`, {
      params: request,
    });
  }

  delete(request: GroupDeleteRequest) {
    return this.instance.delete<GroupDeleteResponse>(`${this.prefix}/${request.id}`);
  }
}
